<script>
export default {
  name: 'chooseItem',
  props: {
    data: {
      type: [Object, String],
      default: () => ({}),
    },
    selected: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    innerBorderActive: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isColor: {
      type: Boolean,
      default: false,
    },
    isPicker: {
      type: Boolean,
      default: false,
    },
    hasDelete: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleSelectItem(value) {
      this.$emit('click-item', value)
    },
    handleDelete(value) {
      this.$emit('click-delete', value)
    },
  },
}
</script>

<template>
  <div :class="['choose-item', { disabled: disabled }]" v-if="!data.hide">
    <div class="delete-btn" v-if="hasDelete" @click="handleDelete(data)">
      <x-icon-delete :reverse="true" />
    </div>
    <div
      class="choose-item__image"
      :style="`background-color: ${data.backgroundColor}`"
      :class="{ 'bg-gray': !innerBorderActive, active: selected }"
      @click="handleSelectItem(data)"
    >
      <div
        :style="`background-color: ${data.backgroundColor}`"
        :class="[
          'image-wrap',
          {
            'inner-border': innerBorderActive,
            'is-color': isColor || isPicker,
          },
        ]"
      >
        <div
          class="color-pattern"
          v-if="isColor"
          :style="`background-color: ${data}`"
        ></div>
        <div class="color-picker" v-else-if="isPicker">
          <span class="color-value" :style="`background-color: ${data}`"></span>
        </div>
        <img :src="data.thumSrc" :alt="data.name" v-else />
      </div>
    </div>
    <p class="choose-item__label" v-if="data.name && showText">
      {{ data.name }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import 'chooseItem.scss';
</style>
